// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._material-design-icon_Fq-2a{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}._externalLink_pbE0W{text-decoration:underline}._externalLink_decorated_AvzkD::after{content:" ↗"}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
